<template>
  <div>
    <el-form size="mini" label-position="top">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_isFactoryInspection') || '是否需要验厂'"
          >
            <el-input v-model="formData.v_isFactoryInspection" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_factoryInspectionMethods') || '验厂方式'"
          >
            <el-input v-model="formData.v_factoryInspectionMethods" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <p class="el-form-item__label m-0 mt-1" style="float:none;text-align:left;">
      {{ $l('form_header_factoryInfoDoc') || '验厂资料' }}
    </p>
    <div class="row doc-row" v-if="listDoc && listDoc.length">
      <div
        v-for="doc in listDoc"
        :key="doc.custDocCode"
        class="col-md-6 col-xl-4"
      >
        <el-card shadow="never" class="doc-card">
          <div class="doc-card-header text-truncate">
            Modify by：{{ doc.uploadName }} at {{ doc.uploadTime }}
          </div>
          <div class="doc-card-body">
            <div class="doc-type-icon d-flex">
              <el-avatar
                shape="square"
                class="bg-transparent"
                :src="doc.custFileIcon"
              />
            </div>
            <div class="doc-info">
              <div class="doc-name">{{ doc.custFileName }}</div>
              <div class="d-flex align-items-center justify-content-between">
                <div style="font-size: 14px;color: #6C757D;">
                  <span class="mr-1">SIZE:</span>
                  <span>{{ doc.custFileSize }}</span>
                </div>
                <div>
                  <span v-if="doc.isAllow">
                    <i
                      class="el-icon-delete tool-btn"
                      style="color: #FA5C7C;"
                      @click="deactivate(doc)"
                    />
                  </span>
                  <span>
                    <i class="el-icon-view tool-btn" @click="view(doc)" />
                  </span>
                  <span>
                    <i
                      class="el-icon-download tool-btn"
                      @click="download(doc)"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <EmptyContent v-else />

    <DeactivateDoc
      :visible.sync="deactivateDocOpts.visible"
      :custDocCode="deactivateDocOpts.custDocCode"
      @reload="getDocData"
    />
  </div>
</template>

<script>
import { request } from '@/api/service'
import EmptyContent from '../empty-content'
import DeactivateDoc from '../cust-folder/components/deactivate-doc'
export default {
  components: { EmptyContent, DeactivateDoc },
  props: { custCode: { type: String, default: '' } },
  data() {
    return {
      formData: {},
      listDoc: [],
      fileIcons: null,
      deactivateDocOpts: { visible: false, custDocCode: '' },
    }
  },
  activated() {
    this.init()
  },
  methods: {
    async init() {
      this.getCustData()
      await this.getFileIcons()
      this.getDocData()
    },
    async getCustData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerV2DetailApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    async getDocData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerDocFactoryInspectionApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      const data = res.body.data

      this.listDoc = data.map((item) => {
        return {
          ...item,
          custFileIcon: this.getFileIcon(item.custFileName),
        }
      })
    },
    async getFileIcons() {
      if (this.fileIcons) return
      const res = await request({
        url: '/sys/common/dict/system',
        method: 'POST',
        data: { dictType: 'FileTypeIcon' },
      }).catch(() => null)

      const data = res?.body?.data || []
      this.fileIcons = Object.fromEntries(
        data.map(({ value, label }) => [value, label])
      )
    },
    getFileIcon(fileName) {
      const getFileType = (filename) => {
        if (!filename) return ''
        if (!filename.includes('.')) return ''
        return filename.split('.').pop()
      }

      const fileType = getFileType(fileName) || 'OTHER'
      return this.$osscdn(
        this.fileIcons[fileType.toUpperCase()] || this.fileIcons['OTHER']
      )
    },
    deactivate({ custDocCode }) {
      this.deactivateDocOpts = { visible: true, custDocCode }
    },
    view({ custFileCode }) {
      this.$api.SYS_FILEDOWNLOAD(custFileCode, {
        isAutoDown: true,
        preview: true,
      })
    },
    download({ custFileCode }) {
      this.$api.SYS_FILEDOWNLOAD(custFileCode)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .doc-card {
    border: 1px solid #ebeef5 !important;
    .el-card__body {
      padding: 0;
      font-size: 14px;
    }
  }

  .el-avatar {
    width: 80px;
    height: 80px;
  }
}
.doc-card-header {
  background-color: #fafafa;
  color: #6c757d;
  line-height: 40px;
  padding: 0 14px;
  border-bottom: 1px solid #ebeef5 !important;
}
.doc-card-body {
  padding: 8px 14px;
  display: flex;
  flex-direction: row;
  .doc-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    .doc-name {
      flex-grow: 1;
      word-break: break-all;
    }
  }
}

.doc-row {
  > div {
    margin-top: 10px;
  }
  > div:nth-child(-n + 3) {
    margin-top: 0;
  }
}
</style>
